(function (window) {
	"use strict";

	function moveAddToCart() {
		const addToCart = document.querySelector(".qty-atc");
		const spiceAddon = document.querySelector("#spiceaddon-holder");
		spiceAddon.insertAdjacentElement("beforebegin", addToCart);
	}

	function moveUpsell() {
		const upsell = document.querySelector("#fbt");
		const reviews = document.querySelector(".review-block-single");
		reviews.insertAdjacentElement("beforebegin", upsell);
	}

	function tweakProductHeader() {
		let titleData = document.querySelector(".product-single__title-data");
		let sku = document.querySelector(".product_sku");
		titleData.insertAdjacentElement("beforeend", sku);

		const shippingMessage = document.querySelectorAll(".active-ship-msg")
		shippingMessage.forEach(node => {
			node.textContent = node.textContent.replace(/^[^A-Za-z0-9]+/, "");
		});
	}

	function stickyAddToCart() {
		let addToCartForm = document.querySelector(".qty-atc");
		let addToCartButton = addToCartForm.querySelector(".product-form__cart-submit");

		let template = `
			<div class="sticky-atc is-visible">
				<button class="sticky-atc__button" type="button">Add to Cart</button>
			</div>
		`

		addToCartForm.insertAdjacentHTML("afterend", template);

		let stickyButton = document.querySelector(".sticky-atc__button");

		stickyButton.addEventListener("click", function () {
			addToCartButton.click();
		});
	}

	function initMobileRedesign() {
		moveAddToCart();
		moveUpsell();
		tweakProductHeader();
		stickyAddToCart();
	}

	window.initMobileRedesign = initMobileRedesign;
})(window);

window.addEventListener("DOMContentLoaded", function () {
    window.initMobileRedesign();
});